module.exports = __webpack_public_path__ + "media/img/teravector-00f15ef4.jpg";